export const img_cdn_link="https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/";

/*
export const Menu_Api_Url=
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1093051&lng=78.9910352&restaurantId=";
*/



  /**/


  export const Menu_Api_Url=
  "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1093051&lng=78.9910352&restaurantId=";